import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  fieldName: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    margin: '0 0 12px 0',
    color: STYLE.COLOR.TEXT2,
  },
  sectionTile: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    marginBottom: '32px',
  },
  profilePicContainer: {
    height: 96,
    width: 96,
    borderRadius: '50%',
    backgroundColor: STYLE.COLOR.WARNING_NOTE,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    position: 'relative',
    cursor: 'pointer',
    marginBottom: 8,
  },
  profileImage: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    objectFit: 'cover',
  },
  cameraIconContainer: {
    position: 'absolute',
    bottom: -24,
    right: -16,
  },
  profilePicText: {
    fontSize: '32px',
    fontWeight: 600,
    lineHeight: '32px',
    color: STYLE.COLOR.TEXT4,
  },
  addImageContainer: {
    marginTop: 24,
  },
  nextButton: {
    minWidth: '220px !important',
  },
  cursorDisabled: {
    cursor: 'not-allowed !important',
  },
  genderContainer: {
    marginTop: `0px !important`,
  },
  genderParent: {
    width: '100%',
  },
  profilePicErrorText: {
    fontSize: '12px',
    fontWeight: 400,
    color: STYLE.COLOR.ERROR,
    margin: '4px 0 0 0',
  },
  profilePicMainContainer: {
    margin: '52px 0px 32px 0px',
  },
  divider: {
    height: '1px',
    backgroundColor: '#EAEAEA',
    width: '100%',
    marginTop: '32px !important',
    marginBottom: '32px !important',
  },
}));
